/**
 * @generated SignedSource<<27f1dd3a0fae346c8eda1ca724182bdf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutUIActionsTransactionSetup_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"checkoutUIReducer_viewer">;
  readonly " $fragmentType": "checkoutUIActionsTransactionSetup_viewer";
};
export type checkoutUIActionsTransactionSetup_viewer$key = {
  readonly " $data"?: checkoutUIActionsTransactionSetup_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutUIActionsTransactionSetup_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutUIActionsTransactionSetup_viewer"
};

(node as any).hash = "158bec93a570b6cab855988c3f056ab8";

export default node;
